import { useState, useEffect } from "react";

export const getSessionStorageValue = (key, defaultValue) => {
  const sessionStorageValue = window.sessionStorage.getItem(key);
  const value = JSON.parse(sessionStorageValue);
  return value !== undefined && value !== null ? value : defaultValue;
};

export const setSessionStorageValue = (key, value) => {
  window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const useSessionStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getSessionStorageValue(key, defaultValue);
  });

  useEffect(() => {
    setSessionStorageValue(key, value);
  }, [key, value]);

  return [value, setValue];
};
